<template>
  <div class="overall-container">
    <p class="overall-label">{{ $t('hm.label.rating.overallTips') }}</p>
    <div class="overall-body">
      <div class="rating">
        <span class="rate-label">{{ $t('hm.label.ratingLabel') }}</span>
        <div class="rete-context">
          <el-rate
            v-model="overall.rateScore"
            :max="6"
            :colors="['#0096cc', '#0096cc', '#0096cc']"
            :disabled="isDisabled"
          ></el-rate>
          <span v-show="rateTips && !overall.rateScore" class="tips">{{ $t('hm.tips.pleaseRate') }}</span>
        </div>
      </div>
      <div class="comment-container">
        <span class="comment-label">{{ $t('hm.label.commentLabel') }}</span>
        <el-input
          type="textarea"
          :autosize="textSize"
          resize="none"
          v-model="overall.comment"
          :readonly="isDisabled"
          class="title">
        </el-input>
      </div>
      <div class="button-container">
        <div
          v-if="reject && !reject.hidden"
          :class="{'disabled': isDisabled || (reject && reject.disabled), 'no-selected': overall.status !== 0, 'reject-status': overall.status === 0}"
          @click="onButtonClick(reject, RATING_UNDERMINED, $event)"
          class="overall-btn reject">
          {{ rejectLabel }}
          <span class="btn-icon iconfont icona-ratingscale2"></span>
        </div>
        <div
          v-if="padding && !padding.hidden"
          :class="{'disabled': isDisabled || (reject && reject.disabled), 'no-selected': overall.status !== 1, 'padding-status': overall.status === 1}"
          @click="onButtonClick(padding, RATING_PADDING, $event)"
          class="overall-btn padding">
          {{ paddingLabel }}
          <span class="btn-icon iconfont icona-ratingscale3"></span>
        </div>
        <div
          v-if="approve && !approve.hidden"
          :class="{'disabled': isDisabled || (reject && reject.disabled), 'no-selected': overall.status !== 2, 'approve-status': overall.status === 2}"
          @click="onButtonClick(approve, RATING_APPROVED, $event)"
          class="overall-btn approve">
          {{ approveLabel }}
          <span class="btn-icon iconfont icona-ratingscale4"></span>
        </div>
      </div>
      <div v-if="showStatusTip && overall.status !== 0 && overall.status !== 1 && overall.status !== 2" class="status-tip">{{ $t('hm.tips.pleaseSelect') }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
const RATING_APPROVED = 2
const RATING_PADDING = 1
const RATING_UNDERMINED = 0

export default {
  components: {
  },
  props: {
    overall: {
      require: true
    },
    buttonOperate: {
      Object: Object
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      RATING_APPROVED,
      RATING_PADDING,
      RATING_UNDERMINED,
      textSize: {
        minRows: 3,
        maxRows: 5
      },
      defaultButtonOPerate: { hidden: false, disabled: false },
      rateTips: false,
      showStatusTip: false
    }
  },
  computed: {
    reject () {
      return this.buttonOperate?.reject || this.defaultButtonOPerate
    },
    padding () {
      return this.buttonOperate?.padding || this.defaultButtonOPerate
    },
    approve () {
      return this.buttonOperate?.approve || this.defaultButtonOPerate
    },
    rejectLabel () {
      const labelI18n = this.buttonOperate?.reject?.labelI18n || 'hm.label.rating.notRecommended'
      return this.$t(labelI18n)
    },
    paddingLabel () {
      const labelI18n = this.buttonOperate?.padding?.labelI18n || 'hm.label.pending'
      return this.$t(labelI18n)
    },
    approveLabel () {
      const labelI18n = this.buttonOperate?.approve?.labelI18n || 'hm.label.rating.Recommended'
      return this.$t(labelI18n)
    }
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {
    onButtonClick (info, status, $event) {
      if (!this.isDisabled) {
        this.overall.status = status
        if (info.onButtonClick) {
          info.onButtonClick(info, $event)
        } else {
          this.$emit('onButtonClick', info, $event)
        }
      }
    },
    verifyOverall () {
      let isValidate = false
      if (this.overall) {
        if (this.overall.rateScore) {
          isValidate = true
        } else {
          isValidate = false
          this.rateTips = true
        }
        if (_.includes([RATING_UNDERMINED, RATING_PADDING, RATING_APPROVED], this.overall.status)) {
          this.showStatusTip = false
          isValidate = true
        } else {
          this.showStatusTip = true
          isValidate = false
        }
      }
      return isValidate
    }
  }
}
</script>

<style lang="scss" scoped>
.overall-container {
  .overall-body {
    background-color: #FFFFFF;
    padding: 40px;

    &> div {
      display: flex;
      justify-content: space-between;
    }

    .rating {
      margin-bottom: 30px;
      align-items: baseline;

      .rete-context {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }

    .comment-container {
      .comment-label {
        margin-right: 40px;
        word-break: keep-all;
        white-space: normal;
      }
    }

    .button-container {
      justify-content: flex-end;
      margin-top: 80px;

      .overall-btn {
        position: relative;
        padding: 5px 20px;
        margin-left: 40px;
        cursor: pointer;

        .btn-icon {
          position: absolute;
          top: -55px;
          left: 50%;
          transform: translate(-50%, 0);
          font-size: 50px;
        }

        &.reject {
          color: #e27676;
        }

        &.padding {
          color: #e6a23c;
        }

        &.approve {
          color: #00a900;
        }

        &.disabled {
          color: #C0C4CC;
          cursor: not-allowed;
        }

        &.reject-status {
          color: #e27676;
        }

        &.padding-status {
          color: #e6a23c;
        }

        &.approve-status {
          color: #00a900;
        }
        &.no-selected {
          color: #C0C4CC;
        }
      }
    }

    .status-tip{
      justify-content: flex-end;
      color: red;
      margin: 0px 10px 0 0;
    }

    .tips {
      color: red;
      margin: 15px 10px 0 0;
    }
  }

  ::v-deep .el-rate {
    .el-rate__item {
      .el-rate__icon {
        &::before {
          font-size: 30px;
        }
      }
    }
  }
}
</style>
